/**
 * Created by 易晓峰(林异)<yxf@106063@alibaba-inc.com> on 07/02/2018.
 */

import _common from './common';

/**
 * 遍历性能的Entity
 * @param max
 * @param cb
 */
const eachEntity = function(cb, max = Number.MAX_VALUE) {
  const performance = getPerformance();
  if (!performance.getEntries) return;
  const entries = performance.getEntries() || [];
  if (!entries.length) return;

  for (let i = 0; i < Math.min(entries.length, max); i++) {
    const entity = entries[i];
    cb && cb(entity);
  }
};

/**
 * 获取performance
 */
function getPerformance() {
  return window.performance ||
		window.webkitPerformance ||
		window.msPerformance ||
		window.mozPerformance || {};
}

/**
 * 收集性能数据
 * @param performance - performance的对象
 * @param exposedTime - 真实的渲染时间
 * @returns {{dns, tcp, ttfb, fbyte, html, load, netType, exposed, new: string, group: *}}
 */
const analysis = function(exposedTime) {
  const performance = getPerformance();
  const timing = performance.timing;
  if (!timing) return;

  return {
    dns: _common.filterValue(timing.domainLookupEnd - timing.domainLookupStart),
    tcp: _common.filterValue(timing.connectEnd - timing.connectStart),
    ttfb: _common.filterValue(timing.responseStart - timing.requestStart),
    html: _common.filterValue(timing.domContentLoadedEventEnd - timing.navigationStart),
    download: _common.filterValue(timing.responseEnd - timing.responseStart),
        // 渲染
    load: _common.filterValue(timing.loadEventEnd - timing.navigationStart),
        // 真实的渲染时间
    exposed: exposedTime ? _common.filterValue(exposedTime - timing.navigationStart) : undefined,
  };
};

export default {
  analysis,
  getPerformance,
  eachEntity,
};



// WEBPACK FOOTER //
// ./src/perf-core.js